import { render, staticRenderFns } from "./PageExploreEvent.vue?vue&type=template&id=3f080c3b&scoped=true&"
import script from "./PageExploreEvent.vue?vue&type=script&lang=js&"
export * from "./PageExploreEvent.vue?vue&type=script&lang=js&"
import style0 from "./PageExploreEvent.vue?vue&type=style&index=0&id=3f080c3b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f080c3b",
  null
  
)

export default component.exports